import http from '../../shared/http.js';
import { bindFormModule } from '../../shared/formBinding.js';
import { closeFormModal, isFormModalOpen, openFormModal } from '../../shared/formModal.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

// Turns the form into the JSON body the API expects.
function readForm(form) {
  const data = Object.fromEntries(new FormData(form).entries());

  // The toggle asks "is this urgent", while the API takes one of three
  // priorities - see utils/ticketArten.js. An unchecked box is not submitted
  // at all, so its absence is what makes a ticket `normal`.
  data.prioritaet = form.querySelector('#ticket-dringend')?.checked ? 'hoch' : 'normal';
  delete data.dringend;

  return data;
}

async function submit(form) {
  const submitButton = form.querySelector('button[type="submit"]');

  if (submitButton) submitButton.disabled = true;
  showLoading('Ticket wird gesendet …');

  try {
    await http.post('/tickets', readForm(form));

    hideLoading();

    // Nothing was saved, so there is no list to refresh and no record to go
    // to - which is why this closes the dialog itself instead of calling
    // formModalSaved(). On the standalone page the form simply resets, since
    // navigating away would be a guess about where the reader came from.
    if (isFormModalOpen()) {
      closeFormModal();
    } else {
      form.reset();
      if (submitButton) submitButton.disabled = false;
    }

    notifySuccess('Ihr Ticket wurde an den Support gesendet. Vielen Dank!');
  } catch (err) {
    hideLoading();
    if (submitButton) submitButton.disabled = false;
    notifyError(
      err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    );
  }
}

export function initTicketForm() {
  // Binds on this page load and again whenever the modal delivers this form,
  // since the element only exists from that moment on.
  bindFormModule('ticket-form', submit);

  // The navbar link. Not initFormModalLinks: that one delegates from a
  // container by selector, and this is a single known link whose href is a
  // real page - the modal is the enhancement.
  const link = document.getElementById('ticket-link');
  if (!link) return;

  link.addEventListener('click', (event) => {
    // Ctrl/Cmd/middle click means "open in a new tab", and the route is a real
    // page, so let the browser have it.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    event.preventDefault();
    openFormModal(link.getAttribute('href'));
  });
}
